// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import history from '../../history';
import AppView from '../layouts/AppView';
import Icon from '../shared/Icon';
import Text from '../shared/Typography';
import Button from '../shared/Button';
import { getRouteTFunction } from '../../i18n';

type Props = WithTranslation
class IntegrationNoRecords extends Component<Props> {
  frameless: boolean;
  props: Props;

  componentWillMount() {
    const framelessParam = new URLSearchParams(window.location.search).get('frameless');
    this.frameless = framelessParam === '1' || framelessParam === 'true';
  }

  render = () => {
    const { t } = this.props;
    const routesTFunction = getRouteTFunction();
    return (
      <AppView frameless={this.frameless}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
        >
          <div style={styles.container}>
            <Icon size='x-large' name='rosetta-neutral' />
            <div style={{ marginTop: 36 }}>
              <Text h1 align='center'>
                {t('records_not_found')}
              </Text>
            </div>
            <div style={{ marginTop: 30, marginBottom: 30 }}>
              <Text paragraph align='center'>
                {t('direct_to_app')}
              </Text>
            </div>
            <Button
              className='is-primary'
              label={t('open_dot')}
              onClick={() => {
                history.push(routesTFunction('redirectPaths./apps'));
              }}
            />
          </div>
        </div>
      </AppView>
    );
  };
}

export default withTranslation('integrationNoRecords')(IntegrationNoRecords);

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 100,
    maxWidth: 600
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/integration-no-records.js